(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-carousel"] && !Shopify.designMode) return;
  try {
    
  class TestimonialCarousel {
    constructor(el) {
      this.el = el;
      this.slides = [...el.querySelectorAll('[data-testimonial-slide]')];
      this.dots = [...el.querySelectorAll('[data-testimonial-dot]')];
      this.current = 0;
      this.total = this.slides.length;
      if (this.total < 2) return;

      const prev = el.querySelector('[data-testimonial-prev]');
      const next = el.querySelector('[data-testimonial-next]');
      if (prev) prev.addEventListener('click', () => this.go(this.current - 1));
      if (next) next.addEventListener('click', () => this.go(this.current + 1));
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));

      this.autoplay = setInterval(() => this.go(this.current + 1), 9000);
      el.addEventListener('mouseenter', () => clearInterval(this.autoplay));
    }

    go(index) {
      this.slides[this.current].classList.remove('is-active');
      if (this.dots[this.current]) this.dots[this.current].classList.remove('is-active');
      this.current = ((index % this.total) + this.total) % this.total;
      this.slides[this.current].classList.add('is-active');
      if (this.dots[this.current]) this.dots[this.current].classList.add('is-active');
    }
  }

  document.querySelectorAll('[data-testimonial-carousel]').forEach(el => new TestimonialCarousel(el));

  } catch(e) { console.error(e); }
})();
})();
